import { ref } from 'vue';
import { isNil } from 'lodash-es';

import { useGetV9AlertAlertRulesReasonByKind } from '@/api-client/metav8Over/queries/meta-alert-rule-v9-controller/meta-alert-rule-v9-controller';
import { ListItem } from '@/config/components/reasonSelect/reasonList/reasonList.types';

export const useReasonData = () => {
  const reasonDataMap = ref(new Map<number, string>());

  const setReasonMap = (items: ListItem[]) => {
    items.forEach((item) => {
      if (!isNil(item.value) && !isNil(item.name)) {
        reasonDataMap.value.set(item.value, item.name);
      }
    });
  };

  type RuleKindParam = Parameters<typeof useGetV9AlertAlertRulesReasonByKind>[0];

  const ruleKind = ref<string>('');
  const { refetch: refetchReason } = useGetV9AlertAlertRulesReasonByKind(
    ruleKind as RuleKindParam,
    {
      query: {
        enabled: false,
        select: (response) => response?.data?.data ?? [],
      },
    },
  );

  const fetchReason = async (kind: string) => {
    if (!kind) {
      return;
    }
    try {
      ruleKind.value = kind;
      const { data } = await refetchReason();
      data?.forEach((item) => {
        if (!isNil(item.eventId) && !isNil(item.reason)) {
          reasonDataMap.value.set(item.eventId, item.reason);
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  const getReasons = (eventIds: number[]) => {
    return eventIds
      .map((id) => {
        return reasonDataMap.value.get(id);
      })
      .filter((reason) => reason) as string[];
  };

  return {
    reasonDataMap,
    setReasonMap,
    fetchReason,
    getReasons,
  };
};
